function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-tree/~/@babel/runtime/helpers/nonIterableSpread.js
// module id = 796
// module chunks = 0